import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {FormModel} from '../../../../common/components/form/models';
import {FormulaireService} from '../../../../common/services/formulaire/formulaire.service';
import {SubSink} from '@Common/core/utils/subsink';
import {SnackBarToastyService, typeToast} from '@Common/widgets/general/snack-bar';

@Component({
  selector: 'app-gestionnaires-list',
  templateUrl: './gestionnaires-list.component.html',
  styleUrls: ['./gestionnaires-list.component.scss']
})
export class GestionnairesListComponent implements OnInit, OnDestroy {

  @Input() formModel: FormModel = null;
  @Input() canDelete = false;
  @Output() onFormLoaded: EventEmitter<FormModel> = new EventEmitter<FormModel>();
  subSink = new SubSink();

  constructor(private formSvc: FormulaireService,
              private snackSvc: SnackBarToastyService) {
  }

  ngOnInit(): void {
  }

  ngOnDestroy() {
    this.subSink.unsubscribe();
  }

  deleteFormGestionnaire(gestUID: string, formUUID: string) {
    this.subSink.sink = this.formSvc
      .delFormGestionnaire(formUUID, gestUID)
      .subscribe(  (form: FormModel) => {
        this.snackSvc.toasty('Gestionnaire', 'Le gestionnaire a bien été enlevé', typeToast.success);
        this.onFormLoaded.emit(form);
      }
    );
  }
}
